var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.455 8.05814L15.4555 1.84188C14.7535 1.29624 13.8894 1 13 1C12.1106 1 11.2465 1.29624 10.5445 1.84188L2.5435 8.05814C2.06267 8.43172 1.67364 8.91014 1.40613 9.45687C1.13863 10.0036 0.999713 10.6042 1 11.2127V22.0028C1 22.7977 1.31607 23.56 1.87868 24.1221C2.44129 24.6842 3.20435 25 4 25H22C22.7957 25 23.5587 24.6842 24.1213 24.1221C24.6839 23.56 25 22.7977 25 22.0028V11.2127C25 9.97936 24.43 8.81494 23.455 8.05814Z",
    stroke: "#1F2023",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.054c9b9c07564c74af64f04cc6cad98e.svg";
export { ForwardRef as ReactComponent };